import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeBody-3'],
    fontWeight: typography['lineHeightBody-4'],
  },
  menuContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['size-4'],
  },
  menuTitle: {
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography['lineHeightCaption-1'],
    color: colors.accentText,
  },
  menu: {
    display: 'flex',
    flexDirection: 'column',
    padding: anatomy['size-4'],
    borderRadius: anatomy.borderRadiusS,
    border: `1px solid ${colors.tertiaryBorder}`,
    backgroundColor: colors.primaryBackground,
    width: '280px',
  },
  menuItem: {
    padding: `${anatomy['size-8']} ${anatomy['size-12']}`,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    borderRadius: anatomy.borderRadiusXs,
    ':hover': {
      backgroundColor: colors.hoverBackground,
    },
    width: '100%',
    textAlign: 'left',
  },
  menuItemSelected: {
    backgroundColor: colors.hoverBackground,
  },
  container: {
    display: 'flex',
    gap: anatomy['size-40'],
    borderRadius: anatomy.borderRadiusS,
    border: `1px solid ${colors.ghostBorder}`,
    padding: anatomy['space-12'],
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: anatomy['size-12'],
  },
  statisticText: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-4'],
    color: palette['grey-500'],
    lineHeight: anatomy['size-24'],
    whiteSpace: 'nowrap',
    ':not(#__unused__) span:first-child': {
      color: colors.accentText,
    },
  },
  statistic: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-4'],
    width: '100%',
    color: colors.primaryInverseText,
    ':not(#__unused__) span': {
      borderRadius: anatomy.borderRadiusXs,
      padding: '6px 14px',
      textAlign: 'center',
      minWidth: 'fit-content',
      background: colors.accentBackground,
    },
    ':not(#__unused__) span:nth-child(2)': {
      background: colors.tertiaryBackground,
    },
    ':not(#__unused__) span:nth-child(3)': {
      background: colors.secondaryBackground,
    },
    ':not(#__unused__) span:nth-child(4)': {
      background: colors.primaryInverseBackground,
    },
  },
  calculateWidth: (width) => ({
    width: `${width * 100}%`,
  }),
  adultWithChild: (width) => ({
    width: `${width * 100}%`,
  }),
  child: (width) => ({
    width: `${width * 100}%`,
  }),
  description: {
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: '12px',
    color: palette['grey-700'],
    marginTop: '10px',
  },
});
